import {css} from '../theme/css'
import {breakpoints} from '../theme/theme'

export const classes = {
  backdrop: css`
    && {
      position: fixed;
      height: auto;
      width: auto;
      inset: 0;
    }
  `,
  modal: css`
    text-align: start;
    position: relative;

    ${breakpoints.down('sm')} {
      max-block-size: 100%;
    }
  `,
}
